import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import Backend from '../../api/backend'

import { setFromWallet } from '../../store/navigate/navigate'
import { BACKEND_PORT, BACKEND_URL } from '../../utils/const'
import CoolCats from '../../api/contract'

import { CatCardGalery } from '../../components/CatCardGalery/CatCardGalery'
import { NoWalletState } from '../../components/NoWalletState/NoWalletState'
import { Preloader } from '../../components/Preloader/Preloader'

import './Wallet.scss'

export const Wallet = () => {
	const dispatch = useDispatch()
	const wallet = useSelector((state) => state.wallet)
	const [list, setList] = useState(null)
	const [address, setAddress] = useState(window.tronWeb ? window.tronWeb.defaultAddress.base58 : '')

	useEffect(() => {
		if (!address) {
			const interval = setInterval(() => {
				if (window.tronWeb && window.tronWeb.defaultAddress.base58)
					setAddress(window.tronWeb.defaultAddress.base58)
			}, 250)

			return () => clearInterval(interval)
		}
	}, [address, setAddress])

	useEffect(() => {
		let isMount = true

		if (address)
			new CoolCats()
				.init(window.tronWeb)
				.then((c) => c.getUserTokens(address))
				.then(async (list) => {
					const marketList = await new Backend(BACKEND_URL, BACKEND_PORT).getUserMarketLots(address)
					if (isMount) setList([
						...marketList.map(el => el.tokenId),
						...list
					])
				})
				.catch((e) => {
					console.log(e)
					if (isMount) setList([])
				})

		return () => (isMount = false)
	}, [address, setList])

	return (
		<div className="wallet-container">
			{ wallet.data.auth && <h1>我的酷猫</h1> }
			{wallet.data.auth ? (
				list ? (
					list.length > 0 ? (
						<div className="images-container">
							{list.map((item, i) => (
								<CatCardGalery
									key={i}
									id={item}
									routeTo="/market"
									onClick={ () => dispatch(setFromWallet(true)) }
								/>
							))}
						</div>
					) : (
						<span>钱包是空的</span>
					)
				) : (
					<Preloader />
				)
			) : (
				<NoWalletState />
			)}
		</div>
	)
}
